import { render, staticRenderFns } from "./lxss.vue?vue&type=template&id=1203ad52&scoped=true"
import script from "./lxss.vue?vue&type=script&lang=js"
export * from "./lxss.vue?vue&type=script&lang=js"
import style0 from "./lxss.vue?vue&type=style&index=0&id=1203ad52&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1203ad52",
  null
  
)

export default component.exports